const {
  PARAM_STR,
  PARAM_DEX,
  PARAM_CON,
  PARAM_INT,
  PARAM_WIT,
  PARAM_CHA,
} = require('./../../../../paramList')
const {
  CREATURE_TYPE_MYCONID,
  CREATURE_TYPE_PLANT,
} = require('./../../../../creatureTypeIdList')
const {
  DAMAGE_BLUDGEONING,
  DAMAGE_POISON,
} = require('./../../../../damageTypeList')
const {ATTACK_MELEE_WEAPON} = require('./../../../../attackTypeList')
const {ALIGNMENT_LN} = require('./../../../../aligmentList')
const {CR_0} = require('./../../../../crList')
const {CREATURE_MYCONID_SPROUT} = require('./../../../../creatureIdList')
const {GENDER_MALE} = require('./../../../../genderList')
const {myconidDescriptionList} = require('./../../../../textCommonParts')
const {SENSE_DARK_VISION} = require('./../../../../senseList')
const {SIZE_SMALL} = require('./../../../../sizeList')
const {SOURCE_MM} = require('./../../../../sourceList')
const {SPEED_WALK} = require('./../../../../speedList')

module.exports = {
  name: 'Росток миконида',
  nameEn: 'Myconid Sprout',
  id: CREATURE_MYCONID_SPROUT,
  description: myconidDescriptionList,
  sizeType: SIZE_SMALL,
  creatureTypeIdList: [
    CREATURE_TYPE_PLANT,
    CREATURE_TYPE_MYCONID,
  ],
  alignmentId: ALIGNMENT_LN,
  source: {
    id: SOURCE_MM,
    page: 209,
  },
  armor: 10,
  hp: {
    diceCount: 2,
  },
  speed: {
    [SPEED_WALK]: 10,
  },
  params: {
    [PARAM_STR]: 8,
    [PARAM_DEX]: 10,
    [PARAM_CON]: 10,
    [PARAM_INT]: 8,
    [PARAM_WIT]: 11,
    [PARAM_CHA]: 5,
  },
  senseList: [
    {
      id: SENSE_DARK_VISION,
      value: 120,
    },
  ],
  cr: CR_0,
  featureList: [
    {
      name: 'Споры страдания',
      description: `Если ★СУЩЕСТВО★ получает урон, все остальные микониды в пределах 240 футов чувствуют его боль.`,
    },
    {
      name: 'Слабость на солнце',
      description: `Находясь на солнечном свету, ★СУЩЕСТВО★ совершает с помехой проверки характеристик, броски атаки и испытания. ★СУЩЕСТВО★ умирает, если проводит больше 1 часа под прямыми солнечными лучами.`,
    },
  ],
  actionList: [
    {
      name: 'Кулак',
      attack: {
        type: ATTACK_MELEE_WEAPON,
        bonus: 1,
        range: 5,
        hit: [
          {
            type: DAMAGE_BLUDGEONING,
            diceCount: 1,
            diceType: 4,
            diceBonus: -1,
          },
          {
            type: DAMAGE_POISON,
            diceCount: 1,
            diceType: 4,
          },
        ],
      },
    },
    {
      name: 'Споры взаимопонимания',
      limit: {
        count: 3,
        period: 'день',
      },
      description: `★СУЩЕСТВО★ выпускает споры в радиусе 10 футов. Эти споры обходят углы и воздействуют только на существ с Интеллектом 2 и выше, которые не являются нежитью, конструктами и элементалями. Попавшие под действие существа могут телепатически общаться друг с другом, если находятся в пределах 30 футов друг от друга. Эффект длится 1 час.`,
    },
  ],
  genderId: GENDER_MALE,
}
